<template>
  <div class="ma-5">
    <a-spin :spinning="isLoading">
      <div class="customers_header">
        <h1 class="font-bold text-xl">Customers</h1>
      </div>
      <div class="customers_info">
        <a-form ref="advertisementForm" :model="form" layout="vertical">
          <a-row>
            <a-col :span="4">
              <a-form-item label="Full Name">
                <p>{{ `${form.first_name} ${form.last_name}` }}</p>
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="Email">
                <p>{{ `${form.email} ` }}</p>
              </a-form-item>
            </a-col>

            <a-col :span="4">
              <a-form-item label="Role">
                <p>
                  {{ form.role && form.role.name }}
                </p>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <a-col :span="4">
              <a-form-item label="Plan">
                <p>
                  {{
                    form.subscription_plan_id == "636842" ? "Annual" : "Monthly"
                  }}
                </p>
              </a-form-item>
            </a-col>
            <a-col :span="4">
              <a-form-item label="Subscription Status">
                <p>
                  <a-tag color="green" v-if="form.subscription_status">
                    ON
                  </a-tag>
                  <a-tag color="red" v-else>
                    OFF
                  </a-tag>
                </p>
              </a-form-item>
            </a-col>
            <a-col :span="3">
              <a-form-item label="Keep?">
                <p
                  v-if="form.cancellation_effective_date"
                  :class="{
                    soon: verifySoonCancellation(
                      form.cancellation_effective_date
                    ),
                    expired: verifyExpiredCancellation(
                      form.cancellation_effective_date
                    ),
                  }"
                >
                  No, {{ formatDate(form.cancellation_effective_date) }}
                </p>
                <p v-else>Yes</p>
              </a-form-item>
            </a-col>
          </a-row>
          <a-row>
            <div class="grid grid-cols-6">
              <a-form-item label="User's Collections">
                <a-select
                  mode="multiple"
                  placeholder="User's collection"
                  option-filter-prop="children"
                  v-model:value="form.user_collections"
                >
                  <a-select-option
                    :value="item.id"
                    v-for="item in collections"
                    :key="item.id"
                  >
                    {{ item.title }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </a-row>
          <a-row>
            <router-link to="/customers">
              <a-button>Cancel</a-button>
            </router-link>
            &nbsp;
            <a-button type="primary" @click="onSubmit" class="ml-3">
              Save
            </a-button>
          </a-row>
        </a-form>
      </div>
    </a-spin>
    <Modal
      v-model:isVisible="modalIsVisible"
      v-model:id="this.$route.params.id"
    />
  </div>
</template>

<script>
import Modal from "@/components/Modals/DeleteAds";
import { ref, computed } from "vue";
import { useStore } from "vuex";
import moment from "moment";

export default {
  components: { Modal },
  async mounted() {
    const data = await this.$store.dispatch(
      "GET_USER_BY_ID",
      this.$route.params.id
    );

    this.form.user_collections = [];

    this.form = { ...this.form, ...data.data };
    for (let col in this.form.collections) {
      this.form.user_collections.push(this.form.collections[col].id);
    }
  },
  setup() {
    const store = useStore();

    const modalIsVisible = ref(false);

    const modal = computed(() => store.state.modalIsVisible);

    const collections = computed(() => store.state.collections);
    const verifySoonCancellation = (date) => {
      const cancellationDate = new Date(date);
      let today = new Date();
      today.setDate(today.getDate() + 7);

      if (cancellationDate < today) {
        return true;
      }
      return false;
    };

    const verifyExpiredCancellation = (date) => {
      const cancellationDate = new Date(date);
      let today = new Date();

      if (cancellationDate <= today) {
        return true;
      }
      return false;
    };
    const formatDate = (value) => {
      return moment(value).format("D MMMM YYYY");
    };
    return {
      modalIsVisible,
      modal,
      verifySoonCancellation,
      verifyExpiredCancellation,
      formatDate,
      collections,
    };
  },
  data() {
    return {
      isLoading: false,
      form: {},
    };
  },
  methods: {
    async onSubmit() {
      const { success } = await this.updateUserCollection();
      if (success) {
        this.$router.push("/customers");
      }
    },
    async updateUserCollection() {
      this.isLoading = true;
      const user_collection = await this.$store.dispatch(
        "UPDATE_USER_COLLECTION",
        { value: this.form.user_collections, id: this.form.id }
      );

      this.isLoading = false;
      return user_collection;
    },
  },
};
</script>

<style scoped>
.custom_select--group {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 20px;
  border: 1px solid #d9d9d9;
  border-radius: 4px;
  padding: 10px;
}
.customers_header {
  height: 80px;
  display: flex;
  align-items: center;
  padding: 0 20px;
}
.customers_info {
  align-items: center;
  padding: 0 20px;
}
.soon {
  @apply bg-yellow-500 text-white px-2;
}
.expired {
  @apply bg-red-500 text-white px-2;
}
</style>
